var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryTaxPaid32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1517.000000, -796.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Taxpaid32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tax-03",
    transform: "translate(2.000000, 4.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tax"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emu",
    transform: "translate(15.258065, 5.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05124281,6.17098854 C4.68305622,5.44798306 5.41153453,5 6.24193548,5 C6.91428158,5 7.72778246,5.53137743 8.74557688,6.48234983 C9.04268711,6.75995365 9.35176659,7.06994189 9.66972686,7.40678469 C10.1421642,7.90727841 10.6113238,8.44219219 11.0565268,8.97697252 C11.3238016,9.29802456 11.5243018,9.54844466 11.6368036,9.69327669 L12.2634453,10.5 L4.74193548,10.5 C3.62449586,10.5 2.60829393,10.0980651 1.88239719,9.34746542 C1.13737258,8.57655452 0.741935484,7.6088849 0.741935484,6.5 C0.741935484,5.3911151 1.13737258,4.42344548 1.88275734,3.65216231 C2.01795986,3.51255181 2.24193548,2.1438485 2.24193548,1.50201416 L3.24193548,1.50201416 L3.24193548,5.5 C3.24193548,5.61389525 3.29297954,5.79396209 3.39258796,6.01297894 C3.46444438,6.17097531 3.55788866,6.34211974 3.6676417,6.52028118 C3.68312728,6.54541883 3.69862175,6.57022457 3.7140807,6.59465805 C3.81351889,6.45720737 3.92601218,6.31429419 4.05124281,6.17098854 Z M1.74193548,6.5 C1.74193548,7.34821284 2.03571561,8.06711884 2.6013538,8.65241048 C3.13226096,9.20138491 3.8872421,9.5 4.74193548,9.5 L10.1903796,9.5 C9.78688912,9.01922839 9.365085,8.54086269 8.94253156,8.09321531 C8.63814721,7.77075465 8.34359686,7.47533827 8.06286318,7.21303581 C7.23418799,6.43876626 6.5624682,6 6.24193548,6 C5.75588441,6 5.26476585,6.30201694 4.80424071,6.82901146 C4.63215791,7.02593163 4.47803997,7.23897263 4.34534552,7.45192495 C4.26667296,7.57818122 4.21393413,7.67381363 4.18955269,7.72279775 L3.84115798,8.42274856 L3.35191804,7.81286801 C3.31607818,7.76819048 3.2567474,7.69103656 3.18160732,7.58793261 C3.05725244,7.41729825 2.93294362,7.23423966 2.81622927,7.04477796 C2.6860131,6.83339884 2.57308184,6.62656375 2.48230809,6.42697238 C2.32882612,6.08949951 2.24193548,5.78297758 2.24193548,5.5 L2.24193548,4.79121367 C1.91179727,5.28481856 1.74193548,5.85502709 1.74193548,6.5 Z",
    id: "Stroke-33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-35",
    points: "7.74193548 12.1666667 6.34193548 10.3 7.14193548 9.7 8.74193548 11.8333333 8.74193548 16.5400383 6.74327826 16.5400383 6.74327826 15.5400383 7.74193548 15.5400383"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-37",
    points: "4.34193548 10.3 5.14193548 9.7 6.82734568 11.9472136 4.55095248 16.5 2.74193548 16.5 2.74193548 15.5 3.93291849 15.5 5.65652529 12.0527864"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Beak",
    x: 0.741935484,
    y: 1.5,
    width: 2,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Head-2",
    cx: 2.74193548,
    cy: 1.5,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13,15 L13,16.9545455 C13,17.5370007 13.4527104,18 14,18 C14.5472896,18 15,17.5370007 15,16.9545455 L15,15 L13,15 Z M16,16.9545455 C16,18.0843182 15.1046667,19 14,19 C12.8953333,19 12,18.0843182 12,16.9545455 L12,14 L16,14 L16,16.9545455 Z",
    id: "shield"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kanga",
    transform: "translate(0.000000, 6.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,14.4 L12.5,14.4 L12.5,15.4 L8,15.4 L8,8.69289322 L10.5,6.19289322 L10.5,4.10710012 L6.84835134,7.75868 C5.93717338,8.64361939 5.5,9.28298145 5.5,9.9 L5.5,11.4 C5.5,13.6807279 3.8009067,15.4 1.5,15.4 L0,15.4 L0,14.4 L1.5,14.4 C3.24596191,14.4 4.5,13.1310687 4.5,11.4 L4.5,9.9 C4.5,8.9163499 5.05149548,8.10979282 6.14644661,7.04644661 L10.2928932,2.9 L11.5,2.9 L11.5,6.60710678 L9,9.10710678 L9,14.4 Z",
    id: "Body"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    points: "8.14760196 11.0464271 8.85466974 11.7535729 5.20784042 15.4 0 15.4 0 14.4 4.79365916 14.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Head-1",
    points: "10 3.403479 10 0.4 13 3.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    points: "12.887448 5 12.9974652 3.4503433 11.5 3.21572491 12.7498798 2.33757258 11.9947808 0.98991137 13.443681 1.44510318 14 0 14.556319 1.44510318 16.0052192 0.98991137 15.2501202 2.33757258 16.5 3.21572491 15.0025348 3.4503433 15.112552 5 14 3.94542551"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryTaxPaid32);
export default __webpack_public_path__ + "static/media/spendCategoryTaxPaid32.19654a846e8d63a6d3db5c7ba6cb08cf.svg";
export { ForwardRef as ReactComponent };